import React from 'react';
import PropTypes from 'prop-types';
const SectionHeader = ({
  title = '',
  disabled = false,
  actionContainerStyles = { textAlign: 'right', flexGrow: 1 },
  containerStyles = {},
  titleContainerStyles = {},
  titleStyles = {
    color: '#32363A',
    fontSize: '18px',
  },
  disabledStyles = {
    color: 'grey',
  },
  enabledStyles = {
    color: 'rgba(13, 99, 203, 1)',
  },
  children = [],
}) => {
  return (
    <div
      className="eureka-section-header"
      style={{
        marginBottom: '0.5rem',
        display: 'flex',
        borderBottom: '1px solid rgba(231, 231, 231, 0.6)',
        ...containerStyles,
      }}
    >
      <div
        style={{
          fontSize: '1.125rem',
          paddingBottom: '0.5rem',
          borderBottom: '1px solid #32363A',
          ...titleContainerStyles,
        }}
      >
        <span style={{ ...titleStyles }}>{title}</span>
      </div>
      <div style={{ ...actionContainerStyles, ...(disabled ? disabledStyles : enabledStyles) }}>
        {children}
      </div>
    </div>
  );
};

SectionHeader.displayName = 'SectionHeader';

SectionHeader.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
  actionContainerStyles: PropTypes.object,
  containerStyles: PropTypes.object,
  titleContainerStyles: PropTypes.object,
  titleStyles: PropTypes.object,
  disabledStyles: PropTypes.object,
  enabledStyles: PropTypes.object,
  children: PropTypes.node,
};

SectionHeader.propDescriptions = {
  title: 'title of section',
  disabled: 'disabled or not',
  actionContainerStyles: 'actions container styles',
  containerStyles: 'whole container styles',
  titleContainerStyles: 'title container styles',
  titleStyles: 'title styles',
  disabledStyles: 'styles when disabled',
  enabledStyles: 'styles when enabled',
  children: 'children',
};

export default SectionHeader;
